// SPDX-License-Identifier: AGPL-3.0-or-later

import type {FlatEmoji} from '@app/features/emoji/types/EmojiTypes';

export function emojiCategoryCollapseKey(categoryId: string): string {
	return `emoji-cat:${categoryId}`;
}

export function uncategorizedCollapseKey(guildId: string): string {
	return `emoji-cat:${guildId}:uncategorized`;
}

export function bucketEmojisByCategory(emojis: ReadonlyArray<FlatEmoji>): {
	byCategoryId: Map<string, Array<FlatEmoji>>;
	uncategorized: Array<FlatEmoji>;
} {
	const byCategoryId = new Map<string, Array<FlatEmoji>>();
	const uncategorized: Array<FlatEmoji> = [];
	for (const emoji of emojis) {
		const categoryId = emoji.categoryId ?? null;
		if (categoryId == null) {
			uncategorized.push(emoji);
			continue;
		}
		let bucket = byCategoryId.get(categoryId);
		if (!bucket) {
			bucket = [];
			byCategoryId.set(categoryId, bucket);
		}
		bucket.push(emoji);
	}
	return {byCategoryId, uncategorized};
}
